import React, { Component} from 'react';
import VideoHead from '../../video/VideoHead';
import ImageRow from '../../imageHead';
import Row from '../../containers/row';
import ImageSlider from '../../imageSlider/index.js';


class TopRow extends Component {
  renderBackground(token) {
    switch(this.props.bundle){
        case "video_with_description":
          return (
            <VideoHead
              token={token}
              className="headVideo" 
              id="headerVideo" 
              width="100%" 
              autoPlay="autoplay" 
              loop="loop"
              media={this.props.field_link_2}
              />
            );  
        case "image_with_description":
          return (
            <ImageRow style={this.props.style} imageStyle={this.props.imageStyle} media={this.props.media} className={this.props.className} />
          );
        case "image_slideshow":
          return <ImageSlider slides={this.props.slides} />;
        default: return (<p>undefined bundle type -- line 10 basic page topRows </p>);
    }
  } 

  render() {      
    return(
      <Row className="topBlock" padding="0"  bgi="none" display="block"
        styles={{
          position:"relative",    
          width:"100%",
          textAlign:"left",
        }}>
        {this.renderBackground(this.props.token)}
      </Row>
    );
  }
}

export default TopRow;
